export default class CustomerHeadquarter {
	name: string;
	cvr: string;
	phoneNumber: string;
	email: string;
	address: string;
	postalCode: string;
	city: string;
	country: string;
	attentionNumber: number;
	attentionName: string;
	attentionEmail: string;
	attentionPhoneNumber: string;

	public isEqual(customerHeadquarter: CustomerHeadquarter): boolean {
		return customerHeadquarter != null
			&& customerHeadquarter.name === this.name
			&& customerHeadquarter.cvr === this.cvr
			&& customerHeadquarter.email === this.email
			&& customerHeadquarter.phoneNumber === this.phoneNumber
			&& customerHeadquarter.address === this.address
			&& customerHeadquarter.postalCode === this.postalCode
			&& customerHeadquarter.city === this.city
			&& customerHeadquarter.country === this.country
			&& customerHeadquarter.attentionEmail === this.attentionEmail
			&& customerHeadquarter.attentionName === this.attentionName
			&& customerHeadquarter.attentionPhoneNumber == this.attentionPhoneNumber
	}
}
